import styled, { css } from 'styled-components';

export const AddGameButtonButtonWrapper = styled.div`
	pointer-events: ${props => (props.isDisabled ? 'none' : 'auto')};
	height: ${props => (props.isDesktop ? '36px' : '32px')};
	width: ${props => (props.orientation === 'landscape' && !props.isDesktop ? '32px' : 'auto')};
	padding: ${props =>
		props.isDesktop ? '0 0 0 10px' : props.orientation === 'landscape' ? '0' : '6px 10px 6px 6px;'};
	border-radius: ${props => (props.isDesktop ? '25px' : ' var(--extras-cta-radius)')};
	background-color: ${props =>
		props.isDesktop ? 'var(--lobby-header-surface-1)' : 'rgb(from var(--lobby-header-text) r g b / 0.15)'};
	opacity: ${props => (!props.isDesktop && props.isDisabled ? 0.5 : 1)};
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: ${props => (props.isDesktop ? 'row-reverse' : 'row')};
	cursor: pointer;
	${props =>
		props.isDesktop &&
		css`
			margin-right: 12px;
		`}
`;

export const AddGameText = styled.span`
	font: ${props => (props.isDesktop ? 'var(--h4-bold)' : 'var(--caption-bold)')};
	color: ${props => (props.isDesktop && props.isDisabled ? 'var(--main-text-disabled)' : 'var(--lobby-header-text)')};
	${props =>
		props.orientation === 'landscape' &&
		css`
			display: none;
		`}
`;

export const AddGameIconContainer = styled.div`
	color: var(--lobby-header-text);
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: ${props => (props.orientation === 'landscape' && !props.isDesktop ? '0' : '2px')};
	svg {
		fill: currentColor;
	}
	${props =>
		props.isDesktop &&
		css`
			background-color: var(--lobby-header-surface-2);
			margin-left: 8px;
			border-radius: 50%;
			width: 32px;
			height: 32px;
		`}
`;
